import { IWebMessageObj } from 'src/app/common/interfaces/webmessage-interface';

export abstract class AbstractAccountService {
  abstract getInformation(
    routingNumber: string,
    accountNumber: string
  ): Promise<IWebMessageObj | undefined>;
}
